<template>
  <DBox
    :id="'cmp-booking-overview-sidewindow-templates'"
    :v-if="booking.templates"
    :addButton="false"
  >
    <NTable
      class="artist-list dbox1"
      :id="'booking-booking-booking_sidewindow-artists'"
      :headers="ListHeader"
      :items="booking.templates"
      :config="tableConfig"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr style="padding: 3px 0px">
          <td v-bind="tdcon('name')">
            <div class="ut-flex" style="width: 100%">
              <div style="flex: 1">
                <div
                  class="txtov"
                  style="max-width: 190px; white-space: initial"
                  :title="item.booking_template_name"
                >
                  {{ item.booking_template_name }}
                </div>
              </div>
              <div style="min-width: 30px; margin-right: 5px">
                <div
                  class="dt-icon-container"
                  @click="(e) => onTemplateView(item)"
                >
                  <img
                    @click="onTemplateView(item)"
                    src="static/icons/eye.svg"
                    class="dt-icon v5 s1"
                    :alt="$t('edit_template')"
                    :title="$t('edit_template')"
                  />
                </div>
              </div>
            </div>
          </td>

          <td
            style="border-right: 0px"
            :title="item.type"
            v-bind="tdcon('type')"
          >
            <span>{{ item.type }}</span>
          </td>
          <td v-bind="tdcon('icon1')">
            <div
              class="parent"
              style="
                width: 100%;
                display: flex;
                justify-content: flex-end;
                padding-right: 12px;
              "
            >
              <div
                class="ut-text-accent5 hidden-txt"
                @click="(e) => onTemplateEdit(item)"
              >
                {{ $t("Use Template") }}
              </div>
              <div
                class="dt-icon-container"
                @click="(e) => onTemplateEdit(item)"
                style="min-width: 30px"
              >
                <img
                  @click="onTemplateEdit(item)"
                  src="static/icons/edit-blue.svg"
                  class="dt-icon v5 s1"
                  :alt="$t('edit_template')"
                  :title="$t('edit_template')"
                />
              </div>
            </div>
          </td>
        </tr>
      </template>
    </NTable>
    <v-dialog v-model="selectUserDialogFlag" width="390">
      <v-card class="dt-modal">
        <div class="dt-modal--header">{{ $t("select_artist") }}</div>

        <div class="dt-modal--body">
          <div class="artist-list dt-list-v2">
            <div
              @click="onArtistClicked(bArtist)"
              class="artist dt-list--item ut-curpoint"
              v-for="bArtist of booking.artists"
              :key="bArtist.artist_id"
            >
              <div
                class="dt-checkbox v2 s1 artist-checkbox"
                v-if="userSelection === UserSelections.Multiple"
              >
                <input
                  type="checkbox"
                  :name="bArtist.artist_name"
                  :id="bArtist.artist_name"
                  :checked="
                    selectedArtists.find(
                      (e) => e.artist_id === bArtist.artist_id
                    )
                  "
                  @click.stop="onArtistClicked(bArtist)"
                />
                <div class="checkmark"></div>
              </div>
              <div class="artist-name">{{ bArtist.artist_name }}</div>
            </div>
          </div>
        </div>
        <div class="dt-modal--options">
          <button class="dt-button s1" @click="cancelArtistSelection">
            {{ $t("cancel") }}
          </button>
          <button
            v-if="userSelection == UserSelections.Multiple"
            class="dt-button s1 v1"
            @click="submitUser"
          >
            {{ $t("ok") }}
          </button>
        </div>
      </v-card>
    </v-dialog>
  </DBox>
</template>

<script>
import qs from "qs";
import * as R from "ramda";

import Dropdown from "../../../../plugins/dropdown/dropdown";
import { getBaseUrl } from "../../../../services/http/http-client";
import {
  BookingService,
  BOOKINGS_STRING,
} from "../../services/booking-service";
import { pick } from "ramda";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import NTable from "@/plugins/datatable/datatable";
export default {
  components: {
    Dropdown,
    NTable,
  },
  props: ["booking"],
  data: () => ({
    userSelection: UserSelections.Single,
    selectUserdialog: UserSelectDialogs.Viewer,
    selectUserDialogFlag: false,
    selectedTemplate: null,
    selectedUser: null,
    selectedArtists: [],
    templateWindow: null,
    templateViewerWindow: null,
    templateEditorWindow: null,
    UserSelections: UserSelections,
    loopTag: 0,
    tableConfig: createNTableConfig({
      headerStyle: 3,
      rowHeight: "auto",
      headerHeight: 32,
      fullHeight: true,
      footer: false,
    }),
  }),
  computed: {
    ListHeader() {
      return [
        createTableHeader("name", { f: 1.9 }),

        createTableHeader("type", { f: 0.6 }),
        createTableHeader("icon1", {
          f: 1.1,
          ta: "right",
          text: this.$t("create_document"),
        }),
      ];
    },
  },
  methods: {
    onTemplateView: function (template) {
      if (!this.booking.artists) {
        throw Error("No Booking Overview Artists Found");
      }
      this.selectedTemplate = template;
      this.selectUserdialog = UserSelectDialogs.Viewer;

      this.getLoopTagAndOpenTemplate();
    },
    onTemplateEdit: function (template) {
      if (!this.booking.artists) {
        throw Error("No Booking Overview Artists Found");
      }

      this.selectedTemplate = template;
      this.selectUserdialog = UserSelectDialogs.Editor;

      this.getLoopTagAndOpenTemplate();
    },
    getLoopTagAndOpenTemplate: function () {
      BookingService.findTemplateFeature(
        this.selectedTemplate.booking_template_id
      ).then((templateFeature) => {
        this.loopTag = templateFeature.loop_tag;
        this.userSelection =
          this.loopTag == 1 ? UserSelections.Multiple : UserSelections.Single;
        if (this.booking.artists.length > 1) {
          this.openSelectArtist();
        } else {
          this.openTemplateWindow();
        }
      });
    },
    openSelectArtist: function () {
      this.selectUserDialogFlag = true;
    },
    onArtistClicked: function (artist) {
      if (this.userSelection === UserSelections.Single) {
        this.selectSingleUser(artist);
      } else if (this.userSelection === UserSelections.Multiple) {
        this.selectMultipleUser(artist);
      }
    },
    selectSingleUser: function (artist) {
      this.selectedArtists = [artist];

      this.selectUserDialogFlag = false;

      this.openTemplateWindow();
    },
    selectMultipleUser: function (artist) {
      if (!this.selectedArtists.find((e) => e.artist_id === artist.artist_id)) {
        this.selectedArtists.push(artist);
      } else {
        this.selectedArtists = this.selectedArtists.filter(
          (e) => e.artist_id !== artist.artist_id
        );
      }
    },
    openTemplateWindow: function () {
      this.templateWindow = window.open(
        getTemplatePopupURL({
          selectUserdialog: this.selectUserdialog,
          loopTag: this.loopTag,
          bookingTemplateId: this.selectedTemplate.booking_template_id,
          calendarDateId: this.booking.cdate?.calendar_date_id,
          selectedArtists:
            this.selectedArtists && this.selectedArtists.length > 0
              ? this.selectedArtists
              : this.booking.artists.slice(0, 1),
          userSelection: this.userSelection,
        }),
        this.selectUserdialog,
        popupWindowDimension
      );

      this.templateWindow.onbeforeunload = () => {
        this.onPopupWindowMessage({
          data: JSON.stringify({
            type: "add_calendar_date_document_success",
          }),
        });
      };

      // window.addEventListener('message', this.onPopupWindowMessage);
    },

    submitUser: function (event) {
      if (this.selectedArtists.length > 0) {
        this.openTemplateWindow();
      }
      this.selectUserDialogFlag = false;
    },
    cancelArtistSelection: function (event) {
      this.selectUserDialogFlag = false;
    },
    onPopupWindowMessage: function (message) {
      message = JSON.parse(message.data);

      switch (message.type) {
        case "add_calendar_date_document_success": {
          window.removeEventListener("message", this.onPopupWindowMessage);
          console.log("add_calendar_date_document_success");
          this.$emit("fetch", true);
          break;
        }
      }
    },
  },
};
const popupWindowDimension = "height=768,width=1366";

const getTemplatePopupURL = ({
  selectUserdialog = UserSelectDialogs.Viewer,
  bookingTemplateId,
  calendarDateId,
  userSelection,
  selectedArtists = [],
  loopTag = 0,
}) => {
  const action =
    selectUserdialog === UserSelectDialogs.Viewer
      ? "render_template"
      : "edit_template_output";

  if (!selectedArtists || selectedArtists.length === 0) {
    throw Error("No User selected");
  }

  const calendarDateArtistId =
    loopTag == 1 ? undefined : selectedArtists[0].calendar_date_artist_id;

  const multiple_artists = selectedArtists.map((e) =>
    pick(
      ["calendar_date_artist_id", "booking_deal_id", "booking_deal_artist_id"],
      e
    )
  );

  console.log(selectedArtists, multiple_artists);

  return `${getBaseUrl()}/booking.pl?${qs.stringify({
    section: BOOKINGS_STRING,
    action,
    booking_template_id: bookingTemplateId,
    calendar_date_id: calendarDateId,
    calendar_date_artist_id: calendarDateArtistId,
    multiple_artists:
      userSelection === UserSelections.Multiple
        ? JSON.stringify(multiple_artists)
        : undefined,
    loop_tag: loopTag,
  })}`;
};

const UserSelectDialogs = {
  Viewer: "Viewer",
  Editor: "Editor",
};

const UserSelections = {
  Single: "Single",
  Multiple: "Multiple",
};
</script>

<style lang="scss" scoped>
.cmp-booking-overview-sidewindow-templates {
  .parent {
    .hidden-txt {
      margin-top: 2px;
      display: none;
      cursor: pointer;
    }

    &:hover {
      .hidden-txt {
        display: block;
      }
    }
  }
}
// .dt-list-item {
//   padding-right: 0px;
// }

// .dt-list-item--text {
//   //color: var(--text-5);

//   line-height: 28px;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
//   color: var(--sprt-1);

//   flex: 1.5;
//   &:nth-child(2) {
//     flex: 0.5;
//   }
// }

// .artist {
//   cursor: pointer;

//   .artist-checkbox {
//     margin-top: 4px;
//     margin-left: 5px;
//     margin-right: 10px;
//   }
//   .artist-name {
//     flex: 1;
//   }
// }
</style>
